import React from "react";
import WelcomeCard from "./WelcomeCard";

const Home = ({ therapist }) => {
  return (
    <div>
      <WelcomeCard therapist={therapist} />
    </div>
  );
};
export default Home;
